import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import "./style.css";
import iconNC from '../../assets/notaCertaBlack.png';
import iconBZ from '../../assets/notaCertaBlack.png';
import { useNavigate } from 'react-router-dom';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Pagamentos = () => {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();
  const handleNavigateTo = (path) => { navigate(path); };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handlePagamento = () => {
    handleNavigateTo("/pagamento")
  }

  return (
    <div>
      <div className="menuLogo">
        Pagamento
      </div>

      <Box sx={{ 
        borderBottom: 1, 
        bgcolor: 'background.paper', 
        borderColor: 'divider' 
      }}>
        <Tabs
        value={value}
        onChange={handleChange}
        scrollButtons={"on"}
        centered
        TabIndicatorProps={{
          style: {
            backgroundColor: "#db3f24"
          }
        }}
        >
          <Tab label="Apps" {...a11yProps(0)} />
          <Tab label="Outros" {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <div className='apps'>
          <div className='apps-banner' 
            style={{background: "linear-gradient(-40deg,#5a7fc7, #4f9ebd, #38b8b6)"}}
            onClick={handlePagamento}
          >
            <div className='apps-image'>
              <img className='apps-logo' id="logoNotaCerta" src={iconNC} alt="Nota Certa" />  
            </div>
          </div>
          <div className='apps-banner' style={{background: "linear-gradient(#c0c0c0,#e6e9eb,#929c9c)"}}>
            <div className='apps-image'>
              <img className='apps-logo' id="logoNotaCerta" src={iconBZ} alt="Nota Certa" />  
            </div>
          </div>
        </div>

      </CustomTabPanel>
      <CustomTabPanel value={value} index={1} >
        Item Two
      </CustomTabPanel>
    </div>
  );

}

export default Pagamentos;